import { createMongoAbility, AbilityTuple, MongoQuery, MongoAbility } from '@casl/ability';


import { InjectionToken } from '@angular/core';

export type AppAbility = MongoAbility<AbilityTuple, MongoQuery>;

export const APP_ABILITY = new InjectionToken<AppAbility>('AppAbility');

export const appAbility = createMongoAbility<AbilityTuple, MongoQuery>([], {
  detectSubjectType: (object) => {
    if ('role' in object) return 'Account';
    return object.constructor?.name;
  }
});